import { Stack, TextField, Typography, ValidationErrors } from "@compass/core";
import { useEffect, useState } from "react";

export const DurationInput = (props: {
  label?: string | undefined;
  required?: boolean;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onBlur?: () => void;
  errors?: ValidationErrors | string[];
  disabled?: boolean;
}) => {
  const [hours, setHours] = useState<number>();
  const [minutes, setMinutes] = useState<number>();

  useEffect(() => {
    if (props.value) {
      const hours = Math.floor(props.value / 60);
      const minutes = props.value % 60;
      setHours(hours);
      setMinutes(minutes);
    } else {
      setHours(undefined);
      setMinutes(undefined);
    }
  }, [props.value]);

  const setDuration = (hours: number | undefined, minutes: number | undefined) => {
    let totalMinutes: number | undefined;
    if (minutes) totalMinutes = Number(minutes);
    if (hours) {
      if (totalMinutes) totalMinutes = totalMinutes + Number(hours) * 60;
      else totalMinutes = Number(hours) * 60;
    }
    props.onChange(totalMinutes);
  };

  const errorMsg = props.errors ? props.errors?.[0] : null;
  const hasError = errorMsg ? true : false;

  return (
    <Stack direction="column" spacing="xs">
      <Stack width="100%" direction="row">
        <TextField
          required={props.required}
          label={`Hours`}
          value={hours}
          onBlur={props.onBlur}
          onChange={(e) => setDuration(e.target.value as unknown as number, minutes)}
          sx={{
            flexGrow: 1,
            marginRight: "-1px",
            "& fieldset": {
              borderTopRightRadius: "0px !important",
              borderBottomRightRadius: "0px !important",
            },
            borderRight: "none !important",
          }}
          type="number"
          error={hasError}
          disabled={props.disabled}
        />
        <TextField
          label={"Minutes"}
          value={minutes}
          onChange={(e) => setDuration(hours, e.target.value as unknown as number)}
          onBlur={props.onBlur}
          sx={{
            flexGrow: 1,
            "& fieldset": {
              borderTopLeftRadius: "0px !important",
              borderBottomLeftRadius: "0px !important",
            },
          }}
          type="number"
          error={hasError}
          disabled={props.disabled}
        />
      </Stack>
      {errorMsg && (
        <Typography color="error" variant="caption">
          {errorMsg}
        </Typography>
      )}
    </Stack>
  );
};
